import OlVectorLayer from 'ol/layer/Vector';

var findFeatureInLayers = (layers, featureId) => {
  var foundFeatures = [];

  if (layers.length > 0) {
    layers.forEach(l => {
      if (l instanceof OlVectorLayer) {
        var found = l.getSource().getFeatureById(featureId);
        if (found) foundFeatures.push(found);
      }
    });

    if (foundFeatures.length > 1) {
      console.error("Feature with duplicate id: ".concat(featureId));
    }
  }

  return foundFeatures[0];
};

export default findFeatureInLayers;